import { useState as U, useCallback as I, useMemo as W, useEffect as g } from "react";
import "./index.es4.js";
import "./index.es20.js";
import { usePLMapboxMapId as et } from "./index.es21.js";
import "./index.es12.js";
import "@tanstack/react-query";
import "qs";
import "@turf/turf";
import { numberFormat as X } from "./index.es278.js";
import "./index.es175.js";
import { rgbArrayToHex as B } from "./index.es277.js";
import "./index.es176.js";
import "./index.es46.js";
import "./index.es6.js";
import { usePLMapboxRefV2 as rt } from "./index.es8.js";
import { usePLMapboxLayersActions as it } from "./index.es13.js";
import { useGetLayerPropsByBasemap as mt } from "./index.es17.js";
import "lodash";
import "react/jsx-runtime";
import { getPallettesByCategoryAndBucket as pt } from "@placer-ui/components";
import "react-map-gl";
import "./index.es230.js";
import "./index.es231.js";
import "./index.es232.js";
import "./index.es233.js";
import "use-debounce";
import "./index.es234.js";
import "./index.es131.js";
import "./index.es166.js";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "./index.es204.js";
import "@deck.gl/layers/typed";
import "./index.es235.js";
import "@sentry/react";
import "mapbox-gl";
import "fabric";
import "./index.es170.js";
import "lodash/fp";
import "lodash/throttle";
import "lodash/debounce";
import "queue";
import "geobuckets";
import "./index.es207.js";
import "./index.es59.js";
import "./index.es74.js";
import "./index.es43.js";
import "kdbush";
import "./index.es82.js";
import "./index.es113.js";
import "@deck.gl/extensions/typed";
import "./index.es208.js";
import "./index.es84.js";
import { usePLMapbox as nt } from "./index.es174.js";
import "./index.es72.js";
import "@deck.gl/geo-layers/typed";
import "@loaders.gl/core";
import "@loaders.gl/mvt";
import "./index.es90.js";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es78.js";
import "@deck.gl/core/typed";
import "./index.es80.js";
import "@deck.gl/aggregation-layers/typed";
import "./index.es99.js";
import "./index.es203.js";
import "./index.es205.js";
import "./index.es206.js";
import { transformRoadData as st } from "./index.es482.js";
import { PLVehicleTrafficVolumePathLayer as at, getLineColor as ct } from "./index.es483.js";
import "./index.es86.js";
import "./index.es209.js";
import "./index.es103.js";
import "react-dom";
import "classnames";
import "./index.es210.js";
import "@deck.gl/mapbox/typed";
import "./index.es211.js";
import "./index.es212.js";
import "./index.es213.js";
import "./index.es214.js";
import "./index.es215.js";
import "./index.es216.js";
import "./index.es217.js";
import "./index.es179.js";
import "./index.es218.js";
import "./index.es219.js";
import "./index.es158.js";
import "./index.es220.js";
import "./index.es221.js";
import "./index.es222.js";
import "./index.es223.js";
import "./index.es224.js";
import "@placer-ui/hooks";
import "./index.es225.js";
import "./index.es226.js";
import "./index.es227.js";
import "./index.es228.js";
import "./index.es236.js";
import "./index.es137.js";
import "./index.es138.js";
import "./index.es237.js";
import "./index.es238.js";
import "./index.es143.js";
import "./index.es239.js";
import "./index.es35.js";
import "./index.es18.js";
import { usePLMapboxDeckStore as lt } from "./index.es23.js";
import { usePLMapboxDeckActions as dt } from "./index.es24.js";
import "./index.es36.js";
import "./index.es45.js";
import "./index.es39.js";
import "./index.es40.js";
import "zustand/react/shallow";
const Y = pt("traffic-volume", 4)[1], ut = [
  "Light Traffic",
  "Medium Traffic",
  "Medium Traffic",
  "Heavy Traffic"
], Pe = ({
  layerGroupId: i,
  fetchFilter: Z,
  visualFilter: $,
  visible: bt
}) => {
  const o = et(), { setCombinedLayersStatus: S, setCombinedLayersData: y } = it(), { updateDeckLayer: V } = dt(), { data: D } = Z, {
    getCarVolumePerDayAtoB: l,
    getCarVolumePerDayBtoA: d,
    getSegmentId: _,
    getRoadType: v,
    getRoadName: u,
    ranges: n,
    filterByRange: L,
    filterByRoadTypes: T,
    onClick: C,
    onHover: P,
    enableFitBound: M,
    fitBoundOptions: R
  } = $, { beforeId: j } = mt(), [F, A] = U(""), [b, H] = U(), { generateTooltip: w, clearHoverTooltip: E, fitBounds: N, addLegendItem: O, removeLegendItem: q } = nt(), k = rt(), z = I((t) => {
    var r, p, s, c, a, f;
    const e = ((s = (p = (r = t == null ? void 0 : t.properties) == null ? void 0 : r.volumes) == null ? void 0 : p.a_to_b) == null ? void 0 : s.cars_per_day) || 0, m = ((f = (a = (c = t == null ? void 0 : t.properties) == null ? void 0 : c.volumes) == null ? void 0 : a.b_to_a) == null ? void 0 : f.cars_per_day) || 0;
    return e + m;
  }, []), x = W(() => n.length === 4 ? n.map((t, e) => ({
    color: B(Y.paletteColors[e]),
    value: "",
    ranges: t,
    visible: !0
  })) : (console.warn("range length must equal to 4"), []), [n]), J = I(
    (t) => {
      for (let e = 0; e < n.length; e++) {
        const [m, r] = n[e];
        if (t >= m && t <= r)
          return e;
      }
    },
    [n]
  ), K = W(() => new at({
    id: i,
    data: D,
    getCarVolumePerDayAtoB: l,
    getCarVolumePerDayBtoA: d,
    getSegmentId: _,
    getRoadType: v,
    roadType: T,
    userInputRange: L,
    hoveredFeatureId: F,
    visibleItems: x,
    beforeId: j,
    onClick: (t) => {
      H(t.object), C && C(t);
    },
    onHover: (t) => {
      var e, m, r, p, s, c;
      if ((m = (e = t.object) == null ? void 0 : e.properties) != null && m.id) {
        A((p = (r = t.object) == null ? void 0 : r.properties) == null ? void 0 : p.id);
        const a = z(t.object), f = u(t.object), G = v(t.object), tt = B(
          ct({
            segmentId: (c = (s = t.object) == null ? void 0 : s.properties) == null ? void 0 : c.id,
            carVolumePerDay: a,
            roadType: G,
            hoveredFeatureId: "",
            roadTypesToShow: new Set(T),
            userInputRange: L || [0, 0],
            visibleItems: x,
            pathType: "inner"
          })
        ), Q = J(a), ot = Q ? ut[Q] : "";
        w({
          mapId: o,
          componentType: "entity-details",
          componentProps: {
            sections: [
              {
                title: f + " - ",
                subtitle: ot,
                colorIndicatorProps: {
                  color: tt
                },
                sectionItems: [
                  {
                    value: X({
                      number: a,
                      maximumFractionDigits: a > 1e3 ? 1 : 0,
                      shorten: !0,
                      formatThousands: !0
                    }),
                    title: "Avg. Cars Per Day",
                    valueSuffixTrend: "positive"
                  }
                ]
              }
            ]
          }
        });
      } else
        A(""), E({ mapId: o });
      P && P(t);
    },
    pickable: !0
  }), [
    j,
    E,
    D,
    L,
    T,
    w,
    J,
    z,
    l,
    d,
    u,
    v,
    _,
    F,
    i,
    o,
    C,
    P,
    x
  ]);
  g(() => {
    if (b) {
      const t = st(b, "", {
        tempLabel: !1,
        isLocked: !1,
        isSelected: !1,
        getCarVolumePerDayAtoB: l,
        getCarVolumePerDayBtoA: d,
        getRoadName: u
      });
      y({
        mapId: o,
        layerId: i,
        data: [{ ...t, isEditing: !0 }]
      }), M && N({
        mapId: o,
        features: [b],
        options: {
          animate: !0,
          ...R
        }
      });
    } else
      y({
        mapId: o,
        layerId: i,
        data: []
      });
  }, [
    M,
    R,
    N,
    l,
    d,
    u,
    i,
    o,
    b,
    y
  ]), g(() => {
    const t = {
      title: "Cars Per Day",
      type: "bins",
      data: n.map((m, r) => ({
        label: m.map(
          (s) => X({
            number: s,
            maximumFractionDigits: s > 1e3 ? 1 : 0,
            shorten: !0,
            formatThousands: !0
          })
        ).join(" - "),
        fillColor: B(Y.paletteColors[r])
      }))
    }, e = O({
      mapId: o,
      item: t
    });
    return () => {
      q({ mapId: o, itemId: e });
    };
  }, [O, q, o, n]);
  const h = I(
    (t) => {
      var m, r, p;
      ((p = (r = (m = lt.getState()) == null ? void 0 : m.maps) == null ? void 0 : r[o]) == null ? void 0 : p.deckRef._deck.pickObject({
        x: t.point.x,
        y: t.point.y,
        radius: 2,
        layerId: i
      })) || H(null);
    },
    [i, o]
  );
  return g(() => (k.on("click", h), () => {
    k.off("click", h);
  }), [h, i, o, k]), g(() => {
    V({ mapId: o, layerId: i, deckLayer: K }), S({ mapId: o, layerId: i, status: "loaded" });
  }, [o, S, V, i, K]), null;
};
export {
  Pe as StaticVTVLayer
};
//# sourceMappingURL=index.es229.js.map
